import UIkit from 'uikit'

export default function (button = ".open-popup") {
	jQuery('body').on('click', button, function (e) {
		e.preventDefault();
		let $button = jQuery(e.currentTarget);
		let target = $button.data('target') || 'modal-form';
		let $popup = jQuery('#' + target);
		UIkit.modal($popup[0]).show();
		jQuery(document).trigger('popup-opened', e.currentTarget);
		$popup.on('hide', function () {
			jQuery(document).trigger('popup-closed');
		});
	});
}
